import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute } from '../route';

const WelcomePage = lazyRouteComponent(
  () => import('./WelcomePage'),
  'WelcomePage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/welcome',
  component: WelcomePage,
  loader: () => ({
    crumb: msg('Welcome', { context: 'page breadcrumb' }),
  }),
});
